import type { ChatroomDataObject, ChatroomTag } from '#models/services';
import { useMutation } from '#react-query';
import { createChatroom } from '../../services';
import { useAddChatroomToCache } from '../cache';

type CreateChatroom = {
  admins: string[];
  name?: string;
  participants: Record<string, CreateChatroomParticipant>;
  ref?: string;
  tags?: ChatroomTag[];
  type?: string;
  users: string[];
};

type CreateChatroomParticipant = {
  email: string;
  firstName: string;
  lastName: string;
};

export const useCreateChatroomMutation = () => {
  const addChatroomToCache = useAddChatroomToCache();

  return useMutation<ChatroomDataObject, Error, CreateChatroom>({
    async mutationFn({ admins, name, participants, ref, tags, type, users }) {
      const { data } = await createChatroom({
        body: {
          admins,
          name,
          participants,
          ref,
          tags,
          type,
          users,
        },
      });

      return data;
    },
    onSuccess(newChatroom) {
      addChatroomToCache({ newChatroom });
    },
  });
};
